import {
  AccessGate,
  type AccessGateVariant,
} from "@mercdev.com/mercurial-ui/display";
import { AccessState, useUser } from "@mercdev.com/mercury-id-authorization";

// Partial: `Granted` renders no gate screen, so it has no variant.
const VARIANT: Partial<Record<AccessState, AccessGateVariant>> = {
  [AccessState.Denied]: "denied",
  [AccessState.NoPortal]: "no-portal",
  [AccessState.Error]: "error",
  [AccessState.Loading]: "loading",
};

// Single screen for every blocked state; rendered inside the providers, so hooks work.
export const StayTuned = () => {
  const { user, accessState, logout } = useUser();

  return (
    <AccessGate
      variant={VARIANT[accessState] ?? "error"}
      avatar={user?.picture}
      onLogout={logout}
    />
  );
};
